export const modalStyleConfig = (directionality) => {
  const isMobile =
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent,
    )
  const modalStyle = { direction: directionality }
  if (isMobile) {
    modalStyle.height = window.innerHeight
  }
  return modalStyle
}
